export default {
  red: {
    weight: {
      light: 'btn-light-red dark:btn-light-red-900/40',
      normal: 'btn-red dark:btn-red-600',
      bold: 'btn-bold-red dark:btn-bold-red-300',
      outline: 'btn-outline-red-700 dark:btn-outline-red-200',
      clear: 'btn-clear-red-700 dark:btn-clear-red-200',
      link: 'btn-link-red dark:btn-link-red-300',
    },
  },
  orange: {
    weight: {
      light: 'btn-light-orange dark:btn-light-orange-900/40',
      normal: 'btn-orange dark:btn-orange-600',
      bold: 'btn-bold-orange dark:btn-bold-orange-300',
      outline: 'btn-outline-orange-700 dark:btn-outline-orange-200',
      clear: 'btn-clear-orange-700 dark:btn-clear-orange-200',
      link: 'btn-link-orange dark:btn-link-orange-300',
    },
  },
  amber: {
    weight: {
      light: 'btn-light-amber dark:btn-light-amber-900/40',
      normal: 'btn-amber dark:btn-amber-600',
      bold: 'btn-bold-amber dark:btn-bold-amber-300',
      outline: 'btn-outline-amber-700 dark:btn-outline-amber-200',
      clear: 'btn-clear-amber-700 dark:btn-clear-amber-200',
      link: 'btn-link-amber dark:btn-link-amber-300',
    },
  },
  yellow: {
    weight: {
      light: 'btn-light-yellow dark:btn-light-yellow-900/40',
      normal: 'btn-yellow dark:btn-yellow-600',
      bold: 'btn-bold-yellow dark:btn-bold-yellow-300',
      outline: 'btn-outline-yellow-700 dark:btn-outline-yellow-200',
      clear: 'btn-clear-yellow-700 dark:btn-clear-yellow-200',
      link: 'btn-link-yellow dark:btn-link-yellow-300',
    },
  },
  lime: {
    weight: {
      light: 'btn-light-lime dark:btn-light-lime-900/40',
      normal: 'btn-lime dark:btn-lime-600',
      bold: 'btn-bold-lime dark:btn-bold-lime-300',
      outline: 'btn-outline-lime-700 dark:btn-outline-lime-200',
      clear: 'btn-clear-lime-700 dark:btn-clear-lime-200',
      link: 'btn-link-lime dark:btn-link-lime-300',
    },
  },
  green: {
    weight: {
      light: 'btn-light-green dark:btn-light-green-900/40',
      normal: 'btn-green dark:btn-green-600',
      bold: 'btn-bold-green dark:btn-bold-green-300',
      outline: 'btn-outline-green-700 dark:btn-outline-green-200',
      clear: 'btn-clear-green-700 dark:btn-clear-green-200',
      link: 'btn-link-green dark:btn-link-green-300',
    },
  },
  emerald: {
    weight: {
      light: 'btn-light-emerald dark:btn-light-emerald-900/40',
      normal: 'btn-emerald dark:btn-emerald-600',
      bold: 'btn-bold-emerald dark:btn-bold-emerald-300',
      outline: 'btn-outline-emerald-700 dark:btn-outline-emerald-200',
      clear: 'btn-clear-emerald-700 dark:btn-clear-emerald-200',
      link: 'btn-link-emerald dark:btn-link-emerald-300',
    },
  },
  teal: {
    weight: {
      light: 'btn-light-teal dark:btn-light-teal-900/40',
      normal: 'btn-teal dark:btn-teal-600',
      bold: 'btn-bold-teal dark:btn-bold-teal-300',
      outline: 'btn-outline-teal-700 dark:btn-outline-teal-200',
      clear: 'btn-clear-teal-700 dark:btn-clear-teal-200',
      link: 'btn-link-teal dark:btn-link-teal-300',
    },
  },
  cyan: {
    weight: {
      light: 'btn-light-cyan dark:btn-light-cyan-900/40',
      normal: 'btn-cyan dark:btn-cyan-600',
      bold: 'btn-bold-cyan dark:btn-bold-cyan-300',
      outline: 'btn-outline-cyan-700 dark:btn-outline-cyan-200',
      clear: 'btn-clear-cyan-700 dark:btn-clear-cyan-200',
      link: 'btn-link-cyan dark:btn-link-cyan-300',
    },
  },
  sky: {
    weight: {
      light: 'btn-light-sky dark:btn-light-sky-900/40',
      normal: 'btn-sky dark:btn-sky-600',
      bold: 'btn-bold-sky dark:btn-bold-sky-300',
      outline: 'btn-outline-sky-700 dark:btn-outline-sky-200',
      clear: 'btn-clear-sky-700 dark:btn-clear-sky-200',
      link: 'btn-link-sky dark:btn-link-sky-300',
    },
  },
  blue: {
    weight: {
      light: 'btn-light-blue dark:btn-light-blue-900/40',
      normal: 'btn-blue dark:btn-blue-600',
      bold: 'btn-bold-blue dark:btn-bold-blue-300',
      outline: 'btn-outline-blue-700 dark:btn-outline-blue-200',
      clear: 'btn-clear-blue-700 dark:btn-clear-blue-200',
      link: 'btn-link-blue dark:btn-link-blue-300',
    },
  },
  indigo: {
    weight: {
      light: 'btn-light-indigo dark:btn-light-indigo-900/40',
      normal: 'btn-indigo dark:btn-indigo-600',
      bold: 'btn-bold-indigo dark:btn-bold-indigo-300',
      outline: 'btn-outline-indigo-700 dark:btn-outline-indigo-200',
      clear: 'btn-clear-indigo-700 dark:btn-clear-indigo-200',
      link: 'btn-link-indigo dark:btn-link-indigo-300',
    },
  },
  violet: {
    weight: {
      light: 'btn-light-violet dark:btn-light-violet-900/40',
      normal: 'btn-violet dark:btn-violet-600',
      bold: 'btn-bold-violet dark:btn-bold-violet-300',
      outline: 'btn-outline-violet-700 dark:btn-outline-violet-200',
      clear: 'btn-clear-violet-700 dark:btn-clear-violet-200',
      link: 'btn-link-violet dark:btn-link-violet-300',
    },
  },
  purple: {
    weight: {
      light: 'btn-light-purple dark:btn-light-purple-900/40',
      normal: 'btn-purple dark:btn-purple-600',
      bold: 'btn-bold-purple dark:btn-bold-purple-300',
      outline: 'btn-outline-purple-700 dark:btn-outline-purple-200',
      clear: 'btn-clear-purple-700 dark:btn-clear-purple-200',
      link: 'btn-link-purple dark:btn-link-purple-300',
    },
  },
  fuchsia: {
    weight: {
      light: 'btn-light-fuchsia dark:btn-light-fuchsia-900/40',
      normal: 'btn-fuchsia dark:btn-fuchsia-600',
      bold: 'btn-bold-fuchsia dark:btn-bold-fuchsia-300',
      outline: 'btn-outline-fuchsia-700 dark:btn-outline-fuchsia-200',
      clear: 'btn-clear-fuchsia-700 dark:btn-clear-fuchsia-200',
      link: 'btn-link-fuchsia dark:btn-link-fuchsia-300',
    },
  },
  pink: {
    weight: {
      light: 'btn-light-pink dark:btn-light-pink-900/40',
      normal: 'btn-pink dark:btn-pink-600',
      bold: 'btn-bold-pink dark:btn-bold-pink-300',
      outline: 'btn-outline-pink-700 dark:btn-outline-pink-200',
      clear: 'btn-clear-pink-700 dark:btn-clear-pink-200',
      link: 'btn-link-pink dark:btn-link-pink-300',
    },
  },
  rose: {
    weight: {
      light: 'btn-light-rose dark:btn-light-rose-900/40',
      normal: 'btn-rose dark:btn-rose-600',
      bold: 'btn-bold-rose dark:btn-bold-rose-300',
      outline: 'btn-outline-rose-700 dark:btn-outline-rose-200',
      clear: 'btn-clear-rose-700 dark:btn-clear-rose-200',
      link: 'btn-link-rose dark:btn-link-rose-300',
    },
  },
  gray: {
    weight: {
      light: 'btn-light-gray dark:btn-light-gray-900/40',
      normal: 'btn-gray dark:btn-gray-600',
      bold: 'btn-bold-gray dark:btn-bold-gray-300',
      outline: 'btn-outline-gray-700 dark:btn-outline-gray-200',
      clear: 'btn-clear-gray-700 dark:btn-clear-gray-200',
      link: 'btn-link-gray dark:btn-link-gray-300',
    },
  },
  slate: {
    weight: {
      light: 'btn-light-slate dark:btn-light-slate-900/40',
      normal: 'btn-slate dark:btn-slate-600',
      bold: 'btn-bold-slate dark:btn-bold-slate-300',
      outline: 'btn-outline-slate-700 dark:btn-outline-slate-200',
      clear: 'btn-clear-slate-700 dark:btn-clear-slate-200',
      link: 'btn-link-slate dark:btn-link-slate-300',
    },
  },
  zinc: {
    weight: {
      light: 'btn-light-zinc dark:btn-light-zinc-900/40',
      normal: 'btn-zinc dark:btn-zinc-600',
      bold: 'btn-bold-zinc dark:btn-bold-zinc-300',
      outline: 'btn-outline-zinc-700 dark:btn-outline-zinc-200',
      clear: 'btn-clear-zinc-700 dark:btn-clear-zinc-200',
      link: 'btn-link-zinc dark:btn-link-zinc-300',
    },
  },
  neutral: {
    weight: {
      light: 'btn-light-neutral dark:btn-light-neutral-900/40',
      normal: 'btn-neutral dark:btn-neutral-600',
      bold: 'btn-bold-neutral dark:btn-bold-neutral-300',
      outline: 'btn-outline-neutral-700 dark:btn-outline-neutral-200',
      clear: 'btn-clear-neutral-700 dark:btn-clear-neutral-200',
      link: 'btn-link-neutral dark:btn-link-neutral-300',
    },
  },
  stone: {
    weight: {
      light: 'btn-light-stone dark:btn-light-stone-900/40',
      normal: 'btn-stone dark:btn-stone-600',
      bold: 'btn-bold-stone dark:btn-bold-stone-300',
      outline: 'btn-outline-stone-700 dark:btn-outline-stone-200',
      clear: 'btn-clear-stone-700 dark:btn-clear-stone-200',
      link: 'btn-link-stone dark:btn-link-stone-300',
    },
  },
};
